// Notes are stored as a Tiptap rich-text doc (opaque to the backend). Our demo
// UI is plain text, so we wrap outgoing text in a minimal Tiptap doc and pull
// the text back out of whatever doc shape comes in. Pure — unit-tested.

/** Wrap plain text into a minimal Tiptap doc (one paragraph). Empty text → an
 *  empty paragraph doc. */
export function toTiptapDoc(text: string): unknown {
  const trimmed = text.trim();
  return {
    type: "doc",
    content: [
      {
        type: "paragraph",
        content: trimmed ? [{ type: "text", text: trimmed }] : [],
      },
    ],
  };
}

/** Extract readable text from a note (a Tiptap doc, or anything). Walks the node
 *  tree collecting `text`, joining paragraphs with newlines; falls back to a
 *  plain string, else "". Defensive — never throws on an unexpected shape. */
export function noteText(note: unknown): string {
  if (typeof note === "string") return note;
  if (!note || typeof note !== "object") return "";
  const paras: string[] = [];
  const walkParagraph = (node: unknown): string => {
    if (!node || typeof node !== "object") return "";
    const content = (node as { content?: unknown }).content;
    if (!Array.isArray(content)) return "";
    return content
      .map((c) => (c && typeof c === "object" && typeof (c as { text?: unknown }).text === "string" ? (c as { text: string }).text : ""))
      .join("");
  };
  const top = (note as { content?: unknown }).content;
  if (Array.isArray(top)) {
    for (const node of top) paras.push(walkParagraph(node));
  }
  return paras.join("\n").trim();
}
